import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {getFavorites, getProduct, makeFavorite} from "../api/ProductsAPI";
import Loading from "../../../layouts/Loading";

import { TbSquareRoundedMinus, TbSquareRoundedPlusFilled} from "react-icons/tb";
import {useCart} from '../../../context/CartContext';
import Header from "../../../layouts/Header";
import {showError, showSuccess} from "../../../utils/toastHelper";
import {MdDeleteForever} from "react-icons/md";


const currencyFormat = Intl.NumberFormat('en-US');
const Products = () => {

    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    const {onPlusClick, onMinusClick, getItemCartCount} = useCart();

    const loaderRef = useRef();




    const fetchProducts = async (pageToLoad = 1, append = false) => {
        if (loading) return;

        try {


            const params = {
                list: 1,
                page: pageToLoad,
                count: 15,
                vendor: 1,

            };



            const data = await getFavorites(params);
            const newItems = data?.data || [];

            setProducts((prev) => (append ? [...prev, ...newItems] : newItems));
            setPage(data.meta ? data.meta.current_page : 1);
            setLastPage(data.meta ? data.meta.last_page : 1);



        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);
        }
    };

    // بارگذاری اولیه
    useEffect(() => {

        setProducts([]);
        setPage(1);
        setLastPage(1);
        fetchProducts(1, false);
    }, []);

    // بارگذاری صفحه بعدی هنگام رسیدن به پایین
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && page < lastPage && !loading) {
                    fetchProducts(page + 1, true);
                }
            },
            {threshold: 1}
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [loaderRef.current, page, lastPage, loading]);


    const onFavoriteClick = async (id) => {
        try {

            setLoading(true)
            const result = await makeFavorite(id);
            showSuccess(result.message);
            fetchProducts(1, false);
        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);
        }
    }

    if (loading) return <Loading/>;


    return (
        <section className="container  mt-3 py-5 rtl px-0  ">
            <Header hasBack={true} transparent={false} title='محصولات نشان شده ' />

            <div className="row ms-3 me-2 pb-5 mb-3">


                {
                    products.map((product, index) => {

                        return (

                            <div className="col-6 col-md-3 px-0 mt-0"

                                 key={product.id}
                            >
                                <div className="row vendor-product m-1">
                                    <div className='p-0 m-0 pt-3 text-start '>
                                      <span className='bg-dark text-white m-2 py-1 px-2 ' style={{ borderRadius: '10px'}}
                                            onClick={() => {onFavoriteClick(product.id)}}
                                      >
                                           <MdDeleteForever className='text-big-5' />
                                      </span>
                                    </div>
                                    <div className="col-12 text-center mt-1"
                                         onClick={
                                             () => {
                                                 navigate(`/product/${product.id}`)

                                             }
                                         }
                                    >
                                        {
                                            product.vendor_price?.discount_percent > 0 &&
                                            <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-primary-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                            </div>
                                        }
                                        <div className="clearfix"></div>
                                        <img src={product.image} alt={product.name}/>

                                    </div>
                                    <div className="col-12 text-center text-small-2" onClick={
                                        () => {
                                            navigate(`/product/${product.id}`)
                                        }
                                    }>
                                        {product.name.substring(0, 30)}
                                    </div>

                                    <div className="col-12 ">
                                        {product.vendor_price?.price ?
                                            <div className=" text-start mt-4 mb-2 text-muted fw-bold text-small-1">

                                                {
                                                    product.vendor_price?.discount_percent > 0 ?
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50 '>
                                                            {currencyFormat.format(product.vendor_price?.price)}
                                                            &nbsp;
                                                            {config.currency}
                                                        </div> :
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50'>
                                                            &nbsp;
                                                        </div>

                                                }

                                                <div>
                                                    {currencyFormat.format(product.vendor_price?.discounted_price)}
                                                    &nbsp;
                                                    <span className='text-small-3 text-muted'>
                                                            {config.currency}
                                                    </span>
                                                </div>


                                            </div>
                                            : ''
                                        }
                                    </div>

                                    {
                                        config.shopping_app_settings.show_plus_minus > 0 &&

                                        <div className={
                                            getItemCartCount(product.id) > 0 ? "add-minus-products text-center mt-0 pt-0 bg-custom rounded" : "add-minus-products text-center mt-0 pt-0"
                                        }>

                                            {

                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="add-product-icon text-secondary "
                                                          onClick={() => {
                                                              onMinusClick(product.id, product.price);

                                                          }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="px-2" onClick={
                                                        () => {
                                                            /* setShowCountBox(true)
                                                             setCountIndex(index)
                                                             setCountId(product.id)
                                                             setCountPrice(product.price)
                                                             setTheCount(getItemCartCount(product.id))*/
                                                        }
                                                    }>
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                (product.inventory > 0 || config.shopping_app_settings.ignore_inventory > 0) ?
                                                    <span className="add-product-icon   "
                                                          onClick={() => {
                                                              onPlusClick(product.id, product.price, product.inventory);

                                                          }}>
                                         <TbSquareRoundedPlusFilled className='text-primary-color'/>
                                    </span>
                                                    :
                                                    <span className='text-danger text-small-2'>
                                                            ناموجود
                                                        </span>
                                            }

                                        </div>
                                    }


                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div ref={loaderRef} style={{height: '1px'}}></div>
        </section>
    );
};

export default Products;